import React, {useEffect} from 'react';
import { useSelector } from 'react-redux';
import {Link} from 'react-router';
import ThemableComponent from "../theme/ThemableComponent";
import {fetchSectionsFromHub} from "../../actions/preCruiseActions";
import { Trans, useLingui } from '@lingui/react/macro';

function PreFormInfo(props) {
    const bookingType = useSelector(state => state.authentication.bookingSubType) || props.bookingType;
    const {t} = useLingui();

    useEffect(() => {
        let category = props.isMedicalMobilityPage ? "prerequisiteTravelInfo" : "travelInfo";
        fetchSectionsFromHub(bookingType, category);
    },[bookingType]);
    
    const surveyUrl = t({id: "/precruise/passenger"}) + `/${props.passengerId}` + t({id: "/form"}) +`${props.isMedicalMobilityPage ? "/medicalAndMobility" : ""}`

    return (
        <div className="my-4 text-grey-darker text-lg leading-middle">

            <ThemableComponent componentName="PreTravelInfoText" isMedicalMobilityPage={props.isMedicalMobilityPage} />

            <Link className="mt-6 mb-8 md:mb-12 block w-mobile action-button action-button-enabled" to={surveyUrl}>
                <Trans id="continue_to_survey">Continue to survey</Trans>
            </Link>
        </div>
    );
}

export default PreFormInfo;